import React from "react";

export default class Constants extends React.Component {
    static ipAddress = 'fixmeeting.eu/';
    static mainUrl = 'https://fixmeeting.eu/';
    static PdfTitleFontSize = 11;
    static PdfNormalFontSize = 10;
    static PdfFooterFontSize = 9;

}